import { useQuery } from "@tanstack/react-query";
import { notNil } from "@utils/array/array-utils";
import { meiliClient as client } from "@utils/search/meilisearch";
import { Hit } from "meilisearch";
import { configs, MultiSearchData } from "./multi-search.configs";

export const useMultiSearch = (searchValue: string) =>
  useQuery({
    queryKey: ["multi-search", searchValue],
    queryFn: async ({ signal }) => {
      if (!searchValue) return { hits: [], hasMoreResults: false };

      const controller = new AbortController();
      signal.addEventListener("abort", () => controller.abort());
      AbortSignal.timeout(7000).addEventListener("abort", () =>
        controller.abort()
      );

      const res = await client.multiSearch<MultiSearchData>(
        {
          federation: { limit: 30 },
          queries: Object.values(configs).map((it) =>
            it.buildQuery(searchValue)
          ),
        },
        { signal: controller.signal }
      );

      const hits = res.hits
        .map((it) =>
          configs[
            it._federation?.indexUid as keyof typeof configs
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ].buildHitData(it as Hit<any>)
        )
        .filter(notNil);
      const estimatedTotalHits = res.estimatedTotalHits || 0;
      return { hits, hasMoreResults: estimatedTotalHits > res.hits.length };
    },
    retry: false,
    staleTime: Infinity,
    placeholderData: (previousData) => previousData,
  });
